import React from "react";

// Below "lgl" (1024px): a vertical card (image on top, centered text below)
// sized for a horizontal swipe strip — same silhouette as the Publications
// and Core Competencies cards. At "lgl" and up: unchanged, the original big
// top image with a centered text column.
//
// Technologies used to be dropped entirely on mobile (the paragraph below is
// "hidden lgl:block") — a project card with no tech stack shown at all. Now
// a handful show as compact pills, capped so an 8-technology project doesn't
// blow out the card.
const MAX_MOBILE_TAGS = 4;

const ProjectsCard = ({ image, title, category, description, technologies }) => {
  const techTags = technologies
    .split(",")
    .map((tech) => tech.trim())
    .filter(Boolean);
  const visibleTags = techTags.slice(0, MAX_MOBILE_TAGS);
  const hiddenTagCount = techTags.length - visibleTags.length;

  return (
    <div className="w-full h-full flex flex-col lgl:flex-col rounded-2xl border border-lineColor bg-surfaceColor overflow-hidden duration-300 hover:border-designColor/50">
      <div className="w-full h-40 sm:h-44 lgl:w-full lgl:h-56 overflow-hidden relative cursor-pointer group shrink-0">
        <img
          className="w-full h-full object-cover scale-100 group-hover:scale-110 duration-300 cursor-pointer"
          src={image}
          alt={title}
        />
        <div className="w-full h-full absolute top-0 left-0 hover:bg-gradient-to-r from-designColor via-designColor to-glowColor opacity-20"></div>
      </div>
      <div className="flex flex-col justify-start items-center lgl:justify-start lgl:items-center flex-1 min-w-0 px-4 py-4 lgl:px-5 lgl:py-5 text-center lgl:text-center">
        <h3 className="font-titleFont text-base lgl:text-lg font-semibold text-strongColor">
          {title}
        </h3>
        <p className="text-xs lgl:text-base text-faintColor lgl:-mt-1">{category}</p>
        <p
          className="clamp-mobile text-sm text-mutedColor mt-2 lgl:mt-2"
          style={{ "--clamp-lines": 2 }}
        >
          {description}
        </p>
        <div className="flex flex-wrap justify-center gap-1.5 mt-2 lgl:hidden">
          {visibleTags.map((tech) => (
            <span
              key={tech}
              className="text-[11px] leading-none text-faintColor border-[1px] border-lineSoft rounded-full px-2 py-1"
            >
              {tech}
            </span>
          ))}
          {hiddenTagCount > 0 && (
            <span className="text-[11px] leading-none text-designColor border-[1px] border-designColor rounded-full px-2 py-1">
              +{hiddenTagCount}
            </span>
          )}
        </div>
        <p className="hidden lgl:block text-xs text-designColor mt-2">
          <strong>Technologies:</strong> {technologies}
        </p>
      </div>
    </div>
  );
};

export default ProjectsCard;
